// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlidpf{flex-grow:0}\n._16jlkb7n{flex-grow:1}\n._1bsb1osq{width:100%}", ""]);
// Exports
module.exports = exports;
